const TOKEN_KEY = "access_token";
const LAST_USED_USERNAME = "last_used_username";

const StorageService = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  saveToken(accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken);
  },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

  get(key) {
    let val = localStorage.getItem(key);

    try {
      return JSON.parse(val);
    } catch (e) {
      return val;
    }
  },

  save(key, value) {
    let tempVal = value;
    try {
      if (value.constructor === Object || value.constructor === Array) {
        tempVal = JSON.stringify(tempVal);
      }
    } catch (e) {}
    localStorage.setItem(key, tempVal);
  },

  remove(key) {
    localStorage.removeItem(key);
  },
  clear() {
    localStorage.clear();
  }
};

export { StorageService, LAST_USED_USERNAME };
